export enum MessageType {
    USER = "USER",
    MACHINE = "MACHINE",
}

export enum IReaction {
    bad = 'bad',
    good = 'good'
}
